<template>
  <v-container
    id="Login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <div
              v-if="!tokencontrato"
            >
              <pages-heading
                class="text-center text-h2"
                :style="styleObject"
              >
                Empresa não encontrada {{ tokencontrato }}
              </pages-heading>
            </div>
            <div v-else>
              <div id="imagem">
                <v-img
                  :src="imagem"
                />
              </div>
              <pages-heading
                id="cabecalho"
                class="text-center text-h2"
                :style="styleObject"
              >
                {{ empresaNome }}
              </pages-heading>
              <pages-heading
                class="text-h3"
                :style="styleObject"
              >
                <b>Recuperação de senha</b>
              </pages-heading>
              <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="reset"
              >
                <v-row
                  v-if="recover.codigoRecuperacao"
                >
                  <v-col>
                    <tex-field-with-validation
                      v-model="recover.codigoRecuperacao"
                      rules="required"
                      type="text"
                      label="Codigo Recuperação"
                      prepend-icon="mdi-key-outline"
                      hidden
                    />
                    <tex-field-with-validation
                      v-model="recover.password"
                      :color="corPrimaria"
                      rules="required"
                      :type="inputType ? 'text' : 'password'"
                      label="Senha"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="inputType = !inputType"
                    />
                    <tex-field-with-validation
                      v-model="recover.repetpassword"
                      rules="required"
                      :color="corPrimaria"
                      required
                      :type="inputType1 ? 'text' : 'password'"
                      label="Repetir Senha"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="inputType1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="inputType1 = !inputType1"
                      @keyup.enter="loader = 'loading', salvar()"
                    />
                    <v-row justify="center">
                      <v-col
                        cols="12"
                        lg="5"
                      >
                        <v-btn
                          id="btnRecover"
                          class="v-btn--block"
                          :loading="loading"
                          :disabled="loading"
                          :color="corPrimaria"
                          small
                          @click="loader = 'loading', salvar()"
                        >
                          Salvar
                          <template v-slot:loader>
                            <span class="custom-loader">
                              <v-icon
                                light
                                :style="styleObject"
                              >mdi-cached</v-icon>
                            </span>
                          </template>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  class="text-center"
                >
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="recover.username"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      type="tel"
                      label="Username"
                      class="text-h6"
                      :color="corPrimaria"
                      prepend-inner-icon="mdi-account"
                      @keyup.enter="loader = 'loading', reset()"
                    />
                  </v-col>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="5"
                    >
                      <v-btn
                        id="btnRecover"
                        class="v-btn--block"
                        :loading="loading"
                        :disabled="loading"
                        small
                        :color="corPrimaria"
                        @click="loader = 'loading', reset()"
                      >
                        Recuperar
                        <template v-slot:loader>
                          <span class="custom-loader">
                            <v-icon
                              light
                              :style="styleObject"
                            >mdi-cached</v-icon>
                          </span>
                        </template>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row justify="center">
                  <v-col
                    cols="12"
                    lg="6"
                  >
                    <div
                      class="center"
                    >
                      Lembrou sua senha.
                      <span>
                        <router-link
                          to="/login"
                          :style="styleObject"
                        >Clique para logar.</router-link>
                      </span>
                    </div><br>
                  </v-col>
                </v-row>
                <base-material-snackbar
                  v-model="snackbar.visible"
                  :timeout="snackbar.timeout"
                  :top="true"
                  :type="snackbar.color"
                >
                  {{ snackbar.message }}
                </base-material-snackbar>
              </v-form>
            </div>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Recover from '../../services/recover'
  import utils from '../../services/utils'
  export default {

    name: 'PageRecover',
    components: {
      PagesHeading: () => import('./components/Heading'),
    },
    mixins: [utils],

    data: () => ({
      valid: false,
      recover: {
        username: '',
        password: '',
        repetpassword: '',
        codigoRecuperacao: '',
      },
      imagem: localStorage.imagem,
      loader: null,
      loading: false,
      empresaNome: '',
      tokencontrato: localStorage.tokencontrato,
      passwordChanged: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },
      corPrimaria: localStorage.corPrimaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      inputType: false,
      inputType1: false,
    }),

    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },

    mounted () {
      this.valid = false
      this.invalid = true

      if (localStorage.tokencontrato) {
        this.tokencontrato = localStorage.tokencontrato

        Recover.verificaEmpresa(this.tokencontrato).then(resposta => {
          this.empresaNome = resposta.data.empresa
          this.imagem = resposta.data.imagem
          localStorage.imagem = this.imagem
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          } else if (e.data.errors === 'Empresa não encontrada') {
            this.empresaNome = ''
            this.tokencontrato = ''
            this.showSnackbar('error', 3000, 'Empresa não encontrada.')
          }
          localStorage.clear()
        })
      }

      if (window.location.href !== 'http://localhost:8080/recover' && window.location.href !== 'http://192.168.1.22:8080/recover' && window.location.href !== 'https://magisvendasweb.com.br/recover' && window.location.href !== 'http://vendas.magisteste/recover') {
        this.recover.link = window.location.href
      }

      if (this.recover.link) {
        Recover.verificaCodigoAtivacao(this.recover.link).then(resposta => {
          this.recover.username = resposta.data.username
          this.recover.codigoRecuperacao = resposta.data.codigoRecuperacao
          localStorage.tokencontrato = resposta.data.tokencontrato
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          }
          localStorage.clear()
          this.$router.push('/login')
        })
      }
    },

    methods: {
      async reset () {
        var url = window.location.href
        await Recover.resetPassword(this.recover.username, url, this.tokencontrato).then(resposta => {
          this.recover.link = resposta.data.linkRecuperacao
          localStorage.link = this.recover.link
          this.showSnackbar('success', 7000, 'Será enviado um email com o link para redefinição de senha, favor confirmar sua caixa de entrada e realizar a alteração da senha.')
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          } else if (e.data.errors === 'Empresa não encontrada') {
            this.empresaNome = ''
            this.tokencontrato = ''
            this.showSnackbar('error', 3000, 'Empresa não encontrada.')
          }
        }).finally(f => { this.exibeProgress = false })
      },

      async salvar () {
        await Recover.newPassword(this.recover, this.tokencontrato).then(resposta => {
          this.passwordChanged = resposta.data.status
          if (this.passwordChanged) {
            this.showSnackbar('sucesss', 3000, 'Senha alterada com sucesso.')
            this.$router.push('/login')
          } else {
            this.recover.codigoRecuperacao = ''
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
          } else if (e.data.message === 'ERRO RECOVER: campo username não foi informado') {
            this.showSnackbar('error', 3000, ' Campo username não foi informado.')
          } else if (e.data.message === 'ERRO RECOVER: campo senha não foi informado') {
            this.showSnackbar('error', 3000, ' Senha não informada')
          } else if (e.data.message === 'ERRO RECOVER: campo repetir a senha não foi informado') {
            this.showSnackbar('error', 3000, ' Campo repetir senha não informado')
          } else if (e.data.message === 'ERRO RECOVER:  Senhas não conferem') {
            this.showSnackbar('error', 3000, ' Senhas não conferem')
          }
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
.v-text-field input
  font-size: 1.2em

#login
  .v-list-item__subtitle
    -webkic-line-clamp: initial
    -webkit-box-orient: initial

  #cabecalho
    color: #4caf50
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
    font-weight: 800 !important

  #imagem
    margin-left: 25%
    margin-right: 25%
    width: 40%
    height: 40%

  #btnRecover
    border-radius: 8px

</style>

<style lang="sass">
  .custom-loader
    animation: loader 1s infinite
    display: flex

  @-moz-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @-webkit-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @-o-keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

  @keyframes loader
    from
      transform: rotate(0)

    to
      transform: rotate(360deg)

</style>
